import React from "react";
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard";
import styles from "./Atlantic.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const tomatoPasteProducts = [
  {
    key: "valmis25_460",
    image: "/assets/products/vegetables/tomato-paste/valmis-tomato-paste-25-460.png",
  },
];

const TomatoPaste = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("vegetables.tomatoPaste.title")}</h2>

      <div className={styles.grid}>
        {tomatoPasteProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`vegetables.products.tomatoPaste.${product.key}.title`)}
            weight={t(`vegetables.products.tomatoPaste.${product.key}.weight`)}
            description={t(`vegetables.products.tomatoPaste.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default TomatoPaste;
